import React from 'react';
import MyJams from '../components/game/MyJams/MyJams';

export const UpcomingEventsPage: React.FC = () => {
  return <MyJams />;
};
